export default "\n  <ion-icon slot=\"top\" size=\"large\" name=\"paper-plane\" (click)=\"openModalWithData()\"></ion-icon>\n  <br>Feedback\n"